import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from '../services/authentication.service';
import {AccessService} from '../services/access.service';

@Component({
  selector: 'app-allotments',
  templateUrl: './allotments.component.html',
  styleUrls: ['./allotments.component.css']
})
export class AllotmentsComponent implements OnInit {
  token;

  constructor(private authService: AuthenticationService,
              private accessService: AccessService) {
  }


  canAccessOIA() {
    return this.accessService.canAccessOIA();
  }

  canAccessOutgoingStudent() {
    return this.accessService.canAccessOutgoingStudent();
  }

  canAccessPOC() {
    return this.accessService.canAccessPOC();
  }

  canAccessIncomingStudent() {
    return this.accessService.canAccessIncomingStudent();
  }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  ngOnInit() {
    if (this.isLoggedIn()) {
      this.token = this.authService.getToken();
    }
  }

}
